import { FC, memo } from 'react';

import CommonCTA from './CommonCTA';

type Props = {
  hasTopPageLink?: boolean;
  internalLink?: {
    path: string;
    text: string;
  };
  inFirstView?: boolean;
  withYellowBackground?: boolean;
};

const PrimaryCTA: FC<Props> = memo(
  ({ hasTopPageLink = false, internalLink, inFirstView, withYellowBackground = true }) => {
    const slideImages = [
      '/images/iqfu/public/cta/cta_slide_01.webp',
      '/images/iqfu/public/cta/cta_slide_02.webp',
      '/images/iqfu/public/cta/cta_slide_03.webp',
      '/images/iqfu/public/cta/cta_slide_04.webp',
      '/images/iqfu/public/cta/cta_slide_05.webp',
    ];

    return (
      <CommonCTA
        hasTopPageLink={hasTopPageLink}
        internalLink={internalLink}
        withYellowBackground={withYellowBackground}
        slideImages={slideImages}
        leadText="「イクラ不動産」って何？"
        ctaLinkText="イクラ不動産に相談する"
        isFirstView={inFirstView}
      />
    );
  },
);

PrimaryCTA.displayName = 'PrimaryCTA';

export default PrimaryCTA;
